import { PATHS } from '../configs';
import client from '../services/client';

import type { ChainStoreInvoice, SupportReceiptType } from '../types';

type GetEasyWalletInitUrlProps = {
  invoice: ChainStoreInvoice;
  email: string | undefined;
  receipt: {
    name: string;
    phone: string;
    barcode?: string;
    type: SupportReceiptType;
    ubn?: string;
    donate?: string;
  };
  callbackParams: {
    serviceUid: string;
    captureMethod: string;
    amount: string;
    merchantUid: string;
  };
};

export const getEasyWalletInitUrl = async ({
  invoice,
  email,
  receipt,
}: GetEasyWalletInitUrlProps) => {
  const {
    data: {
      data: { redirect_link },
    },
  } = await client.initEasyWalletTransaction({
    invoiceId: invoice.id,
    email,
    receipt,
    callbackUrl: `${window.location.origin}${PATHS.INVOICES['']}`,
  });

  return redirect_link;
};
